import { render, staticRenderFns } from "./oAuthAuthorizer.vue?vue&type=template&id=13f36212&scoped=true"
import script from "./oAuthAuthorizer.vue?vue&type=script&lang=js"
export * from "./oAuthAuthorizer.vue?vue&type=script&lang=js"
import style0 from "./oAuthAuthorizer.vue?vue&type=style&index=0&id=13f36212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f36212",
  null
  
)

export default component.exports